<template>
    <Field
        name="countryCode"
        as="select"
        v-model="countryCode"
        class="border border-grey-300 rounded bg-grey-50 w-full p-2 focus:outline-none focus:border-cobalt-500"
    >
        <option v-if="showChoose" value=""> Country</option>
        <option v-for="country in allowedCountries" :key="country.code" :value="country.code">
            {{ country.name }}
        </option>
    </Field>
</template>

<script>
import { ref, watch } from "vue";
import { Field } from "vee-validate";
import countries from "@/countries";

export default {
    name: "CountryCodePicker",
    components: { Field },
    props: {
        modelValue: String,
        showChoose: Boolean,
        preventedCountries: {
            type: Array,
            default: () => [],
        },
        region: {
            type: String,
            default: null,
        },
    },
    setup(props, { emit }) {
        let allowedCountries = countries;
        if (props.region) {
            allowedCountries = countries.filter((country) => country.region === props.region);
        }
        if (props.preventedCountries.length > 0) {
            allowedCountries = allowedCountries.filter(
                (country) => !props.preventedCountries.includes(country.code)
            );
        }

        const countryCode = ref(props.modelValue ? props.modelValue : "");
        watch(countryCode, (currentValue) => {
            emit("update:modelValue", currentValue);
        });

        return { countryCode, allowedCountries };
    }

};
</script>
